<template>
    <div class="layout-footer">
        Powered by
        <a href="https://www.tinextacyber.com" target="_blank">Tinexta Cyber S.p.A</a>
        | <a href="mailto:helpdesk-platforms@tinextacyber.com">helpdesk-platforms@tinextacyber.com</a> |
        <a :href="$t('general.policy_privacy_link')" target="_blank">{{ $t("footer.privacy") }}</a> |
        <a :href="$t('footer.terms_and_conditions_link')" target="_blank">{{
            $t("footer.terms_and_conditions")
        }}</a> |
        <router-link :to="{ name: 'security-measures' }"
            tag="a">{{ $t("pages.security_measures.title") }}</router-link>
    </div>
</template>

<script>
export default {
    name: "AppFooter",
};
</script>

<style scoped>

.layout-footer a {
    color: #03a9f4;
}

.layout-footer a:hover {
    opacity: 0.8;
}

</style>
